var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DialogLayout", {
    attrs: { title: "詳細情報", visible: _vm.dialogVisible, width: "65em" },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      open: _vm.open
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function() {
          return [
            _c("UserMasterForm", {
              ref: "userForm",
              attrs: {
                "label-width": "10em",
                formMode: "edit",
                "autocomplete-user-id-set": _vm.autocompleteUserIdSet,
                "autocomplete-user-name-set": _vm.autocompleteUserNameSet,
                programName: _vm.programName
              },
              model: {
                value: _vm.userFormModel,
                callback: function($$v) {
                  _vm.userFormModel = $$v
                },
                expression: "userFormModel"
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [_c("EditDialogFooter", { on: { update: _vm.clickUpdate } })]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }